import { api } from "./api";
import { CreatePreOrderPayload } from "../constants/types";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export const fetchProductData = async (id: any, endpoint: string) => {
  const url = endpoint + id;
  try {
    const response = await api.get(url, {
      params: {
        page: 1,
        pageSize: 10,
      },
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return response.data.data.product;
  } catch (error: any) {
    console.error(
      "Error fetching products:",
      error.response?.data || error.message
    );
    throw new Error("Failed to fetch product details");
  }
};

export const createPreorder = async (
  payload: CreatePreOrderPayload,
  productId: string
) => {
  try {
    const response = await api.post(
      `/create-prebooking/${productId}`,
      payload,
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Unexpected error in preorder:", error);
    throw new Error("Failed to place preorder.");
  }
};
